import React from "react";

const LikertInputNums = ({ levels, value, pending, disableClicks, handleClick }) => {
  return (
    <div className="flex gap-5">
      {Array.from({ length: levels }).map((_, i) => {
        const levelValue = i + 1;
        const isSelected = value === levelValue;
        const isAnimating = pending === levelValue;

        return (
          <button
            key={levelValue}
            type="button"
            onClick={() => handleClick(levelValue)}
            disabled={disableClicks}
            aria-disabled={disableClicks}
            className={`w-10 h-10 rounded-full text-sm flex items-center justify-center border transition-all duration-500
                  ${
                    isAnimating
                      ? "bg-accent/50 text-white scale-110 shadow"
                      : isSelected
                      ? "bg-accent text-white scale-105 shadow"
                      : "bg-white text-slate-700 border-slate-300 hover:border-slate-400 hover:bg-slate-100"
                  }
                `}
          >
            {levelValue}
          </button>
        );
      })}
    </div>
  );
};

const LikertInputCircles = ({ levels, value, pending, disableClicks, handleClick }) => {
  return (
    <div className="flex items-center gap-5">
      {Array.from({ length: levels }).map((_, i) => {
        const levelValue = i + 1;
        const isSelected = value === levelValue;
        const isAnimating = pending === levelValue;

        const center = (levels + 1) / 2;
        const distanceFromCenter = Math.abs(levelValue - center);

        const maxDistance = Math.max(center - 1, levels - center);
        const t = distanceFromCenter / maxDistance;

        const outerSize = 32 + t * 12; // px → center smallest, edges largest
        const innerSize = 6 + t * 6;

        return (
          <button
            key={levelValue}
            type="button"
            onClick={() => handleClick(levelValue)}
            disabled={disableClicks}
            aria-disabled={disableClicks}
            style={{
              width: outerSize,
              height: outerSize,
            }}
            className={`rounded-full flex items-center justify-center border-2 transition-all duration-500
                ${
                  isAnimating
                    ? "bg-accent scale-110 shadow"
                    : isSelected
                    ? "bg-accent scale-105 shadow"
                    : "border-slate-300 hover:border-slate-400"
                }
              `}
          ></button>
        );
      })}
    </div>
  );
};

export { LikertInputNums, LikertInputCircles };
